<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted(){
    console.log(416578204)
    console.log(this.$route.path)
    if (this.$route.path === '/') {
      console.log(this.$route.query)
      localStorage.removeItem(this.$route.query.Shopid+"pickindex")
      localStorage.removeItem(this.$route.query.Shopid+"pickxb")
      localStorage.removeItem(this.$route.query.Shopid+"list")
      localStorage.removeItem("list")
      localStorage.removeItem("pickxb")
      localStorage.removeItem("pickindex")
      console.log(1231231231)
    }
  },
  destroyed() {
    console.log(this.$route.query)
    localStorage.removeItem(this.$route.query.Shopid+"pickindex")
    localStorage.removeItem(this.$route.query.Shopid+"pickxb")
    localStorage.removeItem(this.$route.query.Shopid+"list")
    localStorage.removeItem("list")
    localStorage.removeItem("pickxb")
    localStorage.removeItem("pickindex")
    console.log(1231231231)
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue